"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PanelTransition;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TwoWayTransition = _interopRequireDefault(require("../../transitions/TwoWayTransition"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

var _times = require("HubStyleTokens/times");

var _sizes = require("HubStyleTokens/sizes");

var PanelTransitionWrapper = (0, _styledComponents.default)(function (_ref) {
  var __align = _ref.align,
      open = _ref.open,
      transitioning = _ref.transitioning,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["align", "open", "transitioning"]);
  return _react.default.createElement(_TwoWayTransition.default.PlainWrapper, Object.assign({
    "data-component-name": "UIPanel",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "PanelTransition__PanelTransitionWrapper",
  componentId: "sc-1snbz7s-0"
})(["transition-property:", ";transition-duration:", "ms;transform:", ";position:fixed;top:0;bottom:0;z-index:", ";", ";"], function (_ref2) {
  var transitionActive = _ref2.transitionActive;
  return transitionActive ? 'transform' : 'none';
}, function (_ref3) {
  var duration = _ref3.duration;
  return duration;
}, function (_ref4) {
  var align = _ref4.align,
      open = _ref4.open;
  if (open) return 'translateX(0%)';
  return align === 'left' ? 'translateX(-100%)' : 'translateX(100%)';
}, _sizes.JUPITER_LAYER, function (_ref5) {
  var align = _ref5.align;
  return align === 'right' ? 'right: 0;' : 'left: 0;';
});

function PanelTransition(props) {
  return _react.default.createElement(_TwoWayTransition.default, Object.assign({}, props, {
    ContextProvider: _ModalTransitionContext.ModalTransitionContextProvider,
    transitionOnMount: true
  }));
}

PanelTransition.propTypes = {
  align: _propTypes.default.oneOf(['left', 'right']).isRequired,
  duration: _propTypes.default.number.isRequired,
  Wrapper: _propTypes.default.elementType.isRequired
};
PanelTransition.defaultProps = {
  align: 'right',
  duration: parseInt(_times.PANEL_TRANSITION_TIMING, 10),
  Wrapper: PanelTransitionWrapper
};
PanelTransition.displayName = 'PanelTransition';
module.exports = exports.default;